import React from 'react';
import block from 'bem-cn';
import { Link } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import SVG from 'components/SVG';
import { actions as appActions } from 'features/app';
import useSuperadminBonusSistem from 'features/promotions/SuperadminBonusSistem/model';

import titlePlanshSVG from 'shared/img/promotions/SuperadminBonusSistem/title-plansh.svg';
import slotIconPNG from 'shared/img/promotions/SuperadminBonusSistem/slot-icon.png';
import dotSVG from 'shared/img/promotions/SuperadminBonusSistem/dot.svg';
import arrowUpSVG from 'shared/img/promotions/SuperadminBonusSistem/arrow-up.svg';
import lightLSVG from 'shared/img/promotions/SuperadminBonusSistem/light-left.svg';
import lightRSVG from 'shared/img/promotions/SuperadminBonusSistem/light-right.svg';

import './SuperadminBonusSistemMenuWidget.scss';

const b = block('superadmin-bonus-sistem-menu-widget');

const SUPERADMIN_BONUS_SISTEM_ROUTE = '/superadmin-bonus-sistem';

const SuperadminBonusSistemMenuWidget = () => {
  const dispatch = useDispatch();

  const locale = useSelector(
    state => state.locale.locale.superadminBonusSistem,
    shallowEqual,
  );

  const {
    isVisible,
    isLoading,
    isLoaded,
    currentGrade,
    menuWidget,
  } = useSuperadminBonusSistem();

  if (!isVisible || !isLoaded || !menuWidget) return null;

  const {
    gradeName,
    depositBonusPercent,
    progressPercent,
    isMaxGrade,
  } = menuWidget;

  const progressValue = Math.round(progressPercent);
  const currentGradeName = locale.grades?.[currentGrade?.id] || gradeName;

  const handleClick = () => {
    dispatch(appActions.changeSideMenuOpened(false));
  };

  return (
    <Link
      to={SUPERADMIN_BONUS_SISTEM_ROUTE}
      className={b({ grade: currentGrade?.id, loading: isLoading })}
      onClick={handleClick}
    >
      <div className={b('icon-right')}>
        <SVG svgProps={{ svg: lightRSVG }} />
      </div>
      <div className={b('header')}>
        <div className={b('title')}>
          <div className={b('title-name')}>{locale.title}</div>
          <SVG className={b('title-bg')} svgProps={{ svg: titlePlanshSVG }} />
        </div>
        <img className={b('icon')} src={slotIconPNG} alt="" />
        <div className={b('icon-left')}>
          <SVG svgProps={{ svg: lightLSVG }} />
        </div>
      </div>

      <div className={b('content')}>
        <div className={b('level')}>
          <div className={b('level-label')}>
            <div className={b('level-label-text')}>{locale.currentStatus}</div>
            <div className={b('level-label-img')}>
              <SVG svgProps={{ svg: dotSVG }} />
            </div>
          </div>
          <span className={b('level-value')}>{currentGradeName}</span>
        </div>

        <div className={b('bonus')}>
          <div className={b('bonus-value')}>
            <div className={b('bonus-value-left')}>
              <SVG svgProps={{ svg: arrowUpSVG }} />
            </div>
            <div className={b('bonus-value-right')}>+{Number(depositBonusPercent).toFixed(2)}%</div>
          </div>
          <span className={b('bonus-label')}>{locale.onEveryDeposit}</span>
        </div>

        {!isMaxGrade && (
          <div className={b('progress')}>
            <div
              className={b('progress-line')}
              role="progressbar"
              aria-valuenow={progressValue}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                className={b('progress-value')}
                style={{ width: `${progressPercent}%` }}
              />
              <div
                className={b('progress-percent')}
                style={{ left: `clamp(1.5rem, ${progressPercent}%, calc(100% - 1.5rem))` }}
              >
                {progressValue}
                <span>%</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </Link>
  );
};

export default SuperadminBonusSistemMenuWidget;